import React from "react";
import InputTextArea from "../../components/InputTextArea/InputTextArea";

function QuestionAnswerTextArea({question, answer, onPut, completed}) {

    if (!question) return null;

    function handleChange(e) {
        const answerValue = e.target.value;
        const answerData = {
            id: answer ? answer.id : null,
            questionId: question.id,
            value: answerValue
        }

        putAnswer(answerData);
    }

    function putAnswer(answerData) {
        onPut(answer, answerData)
    }

    return (
        <InputTextArea
            name={question.id}
            label={question.title}
            description={question.description}
            defaultValue={answer?.value ?? ""}
            onChange={handleChange}
            disabled={completed}
        />
    );
}

export default QuestionAnswerTextArea;